<template>
  <section class="faq">
    <div class="faq-container">
      <div class="faq-content">
        <FaqImages/>

        <div class="faq-accordion">
          <div class="section-header">
            <span class="section-label">{{ t('index.faq.label') }}</span>
            <h2 class="section-title">{{ t('index.faq.title') }}</h2>
          </div>

          <UIAccordion
            :items="accordionItems"
            variant="faq"
          >
            <template #body="{ item }">
              <div class="faq-answer-html" v-html="item.answer" />
            </template>
          </UIAccordion>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t, te } = useI18n()

const faqItems = computed(() => {
  const items = [
    { question: t('index.faq.item1Question'), answer: t('index.faq.item1Answer') },
    { question: t('index.faq.item2Question'), answer: t('index.faq.item2Answer') },
    { question: t('index.faq.item3Question'), answer: t('index.faq.item3Answer') },
    { question: t('index.faq.item4Question'), answer: t('index.faq.item4Answer') }
  ]
  if (te('index.faq.item5Question') && te('index.faq.item5Answer')) {
    items.push({
      question: t('index.faq.item5Question'),
      answer: t('index.faq.item5Answer')
    })
  }
  return items
})

const accordionItems = computed(() =>
  faqItems.value.map(({ question, answer }) => ({ title: question, answer }))
)
</script>

<style scoped>
.faq {
  padding: 80px 0;
  max-width: var(--max-width-container);
  margin: 0 auto;
}

.faq-container {

  margin: 0 auto;
  padding: 0 0px 0 0;
}

.faq-content {
  display: grid;
  grid-template-columns: 0.95fr 1fr;
  gap: 10px;
  align-items: start;
  margin-top: 40px; 
}

.faq-content > * {
  min-width: 0;
}

.faq-accordion {
  display: flex;
  flex-direction: column;
  gap: 29px;
}

.faq-accordion .section-header {
  text-align: left;
  margin-bottom: 0;
}

.section-title {
  max-width: 100% !important;
}

/* Відступи між абзацами з v-html (надійніше за подвійний <br>) */
.faq-answer-html :deep(p) {
  margin: 0 0 0.75em;
}

.faq-answer-html :deep(p:last-child) {
  margin-bottom: 0;
}

@media (max-width: 1400px) {
  .faq-container {
    padding: 0 60px;
  }
}
@media (max-width: 1200px) {
  .faq-content {
    grid-template-columns: 1fr 1.2fr;
  }
}
@media (max-width: 991px) {
  .faq {
    padding: 60px 0;
  }

  .faq-container {
    padding: 0 30px;
  }

  .faq-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}

@media (max-width: 767px) {
  .faq {
    padding: 40px 0;
  }

  .faq-container {
    padding: 0 15px;
  }

  .faq-content {
    gap: 30px;
  }
}

@media (max-width: 575px) {
  .faq-container {
    padding: 0 10px;
  }
}
@media (max-width: 480px) {
  .faq {
    padding: 40px 0 60px;
  }
  .faq-content {
    margin-top: 14px;
  }
  .faq-accordion .section-header {
  text-align: center;
}
.faq-accordion {
  gap: 0px;
}
}
</style>

